import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '../store'
import { getToken } from '@/utils/auth'
import { host } from '@/config/config'
import router from '@/router'

// 创建axios实例
const service = axios.create({
  baseURL: host, // api的base_url
  timeout: 60000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
  if (getToken()) {
    config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
  /**
  * code为非20000是抛错 可结合自己业务进行修改
  */
    const res = response.data
    if (response.status !== 200) {
      Message({
        message: res.message,
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject('error')
    } else {
      // 需短信验证
      if (response.data.code === 40001) {
        // 跳转到短信认证页面
        router.push({name: "smsAuth"})
      }
      return response.data
    }
  },
  error => {
    if (!error.response) {
      Message({
        message: '网络异常',
        type: 'error',
        duration: 3 * 1000
      })
      return Promise.reject(error)
    }
    const res = error.response
    if (error.config.url.indexOf('/oauth/token') !== -1) {
      Message({
        message: res.data.error_description === 'Bad credentials' ? '用户名或密码错误' : res.data.error_description,
        type: 'error',
        duration: 3 * 1000
      })
      return Promise.reject(error)
    }
    // 401:非法的token
    if (res.status === 401) {
      /* MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
        confirmButtonText: '重新登录',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
      })*/
      store.dispatch('FedLogOut').then(() => {
        location.reload()// 为了重新实例化vue-router对象 避免bug
      })
    } else if (res.status === 403) {
      // @TODO
    } else if (res.status === 400) {
    } else {
      console.log('err' + error)// for debug
      Message({
        message: error.message,
        type: 'error',
        duration: 3 * 1000
      })
    }
    return Promise.reject(error)
  }
)

export default service
